import React from "react";
import { withRouter } from "react-router";

import Header from "components/library/Header";
import HeaderLinkGroup from "dashboard/components/HeaderLinkGroup";
import NewItemDropdown from "dashboard/components/NewItemDropdown";
import logo from "assets/img/logo.png";

import styles from "./CurationHeader.css";

class CurationHeader extends React.Component {
  constructor(props) {
    super(props);

    this.dashboardLinks = [
      { to: "/curation/", children: "Drafts" },
      { to: "/curation/published/", children: "Published" },
    ];
  }

  render() {
    const items = [{ children: "Deep Dive", to: "/editor/deep-dive/" }];

    return (
      <div className={styles.root}>
        <Header
          center={
            <>
              <HeaderLinkGroup
                className={styles.desktopHeaderLinks}
                links={this.dashboardLinks}
              />
              <img src={logo} className={styles.logo} />
            </>
          }
          right={<NewItemDropdown items={items} />}
        />
        <Header
          className={styles.mobileHeader}
          center={<HeaderLinkGroup links={this.dashboardLinks} />}
        />
      </div>
    );
  }
}

export default withRouter(CurationHeader);
